import React from 'react'
import { ReactComponent as Success } from '../../../assets/svgs/success.svg'
import { ReactComponent as Warning } from '../../../assets/svgs/warning.svg'
import { ReactComponent as Error } from '../../../assets/svgs/error.svg'
import { t } from '../../../utils/i18n'
import './meta-card.scss'

type MetaEntry = {
  nextUrl: string | null
  error: string | null
  status: 'SUCCESS' | 'FAILED' | 'IN_PROGRESS' | string
  lastAttemptedAt: number
  syncInterval: number
}

type MetaData = Record<string, MetaEntry>

interface MetaCardsProps {
  metaData: MetaData
}

const MetaCards: React.FC<MetaCardsProps> = ({ metaData }) => {
  const renderIcon = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'success':
        return <Success />
      case 'failed':
        return <Error />
      case 'in_progress':
        return <Warning />
      default:
        return '-'
    }
  }

  return (
    <div className="meta-cards-wrapper force-scrollbar">
      {Object.entries(metaData).map(([key, val]) => {
        if (key === 'businessUsers') {
          return
        }
        const nextSyncAt = new Date(val.lastAttemptedAt + val.syncInterval).toLocaleString()
        const capitalizedStatus =
          val?.status?.charAt(0)?.toUpperCase() + val?.status?.slice(1)?.toLowerCase()

        return (
          <div className={`${key} card-wrapper`} key={key}>
            <div className="top">
              {renderIcon(val.status)}
              <p className="body-xs-bold">{t(key)}</p>
            </div>
            <span className="body-xs">
              {t('meta.info')
                .replace('{{status}}', capitalizedStatus)
                .replace('{{nextSyncAt}}', nextSyncAt)}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default MetaCards
